import { IconContent } from '@icons';

export const topBar: IconContent = {
    sm: '<path fill-rule="evenodd" d="M3 5V3h10v2H3ZM2 6V2h12v12H2V6Zm11 0H8.5v7H13V6Zm-5.5 7H3V6h4.5v7Z" />',
    md: '<path fill-rule="evenodd" d="M0 14h14V0H0v14ZM1 1v2.666h12V1H1Zm12 12V4.666H7.5V13H13Zm-6.5 0H1V4.666h5.5V13Z" />',
};
